import { commonStrings, inventoryStrings } from "../components/StringBundle";

// auditlog table columns
export const auditLogColumns = [
  {
    title: "Field",
    dataIndex: "field",
    key: "field",
    width: "15%",
  },
  {
    title: "Old value",
    dataIndex: "oldValue",
    key: "oldValue",
    width: "15%",
  },
  {
    title: "New value",
    dataIndex: "newValue",
    key: "newValue",
    width: "15%",
  },
  {
    title: "Modified By",
    dataIndex: "createdBy",
    key: "createdBy",
    width: "15%",
  },
  {
    title: "Modified Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: "15%",
  },
];


// attachments columns
export const attachmentsColumns = (handleDownload) => [
  {
    title: "File Name",
    dataIndex: "name",
    key: "name",
    width: "20%",
    render: (text, record) => (
      <a onClick={(e) => handleDownload(e, record)}>{text}</a>
    ),
  },
  {
    title: "URI",
    dataIndex: "uri",
    key: "uri",
    width: "20%",
  },
  {
    title: "Created By",
    dataIndex: "createdBy",
    key: "createdBy",
    width: "15%",
  },
  {
    title: "Created Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: "15%",
  },
];

// inventory table location columns
export const inventoryLocationCols = [
  { headerName: inventoryStrings.location, field: "locationName", align: "left" },
  { headerName: inventoryStrings.totalQuantityOnHand, field: "totalQuantityOnHand" },
  { headerName: inventoryStrings.totalQuantityCommitted, field: "totalQuantityCommitted" },
  { headerName: inventoryStrings.totalQuantityBackOrdered, field: "totalQuantityBackOrdered" },
  { headerName: inventoryStrings.averageCost, field: "averagePrice" },
];

// inventory table sublocation columns
export const inventorysubLocationCols = [
  { headerName: inventoryStrings.sublocationName, field: "sublocationName", align: "left" },
  { headerName: inventoryStrings.quantityOnHand, field: "quantityOnHand" },
  { headerName: inventoryStrings.quantityCommitted, field: "quantityCommitted" },
  { headerName: inventoryStrings.quantityBackOrdered, field: "quantityBackOrdered" },
  { headerName: inventoryStrings.averageCost, field: "averagePrice" },
];

export const companyOptions = [    
  { label: commonStrings.ccl, value: "CCL" },
  { label: commonStrings.ncl, value: "NCL" },
];




